/**
 * How a Multi_Select field's selected values join into one string in generated documents and
 * report cells. Mirrors the Kotlin `RenderSeparator` enum. Null/absent on a field means COMMA.
 *
 * Note this never applies to `ee-tag` chip display, which renders one chip per value and so has
 * no joined string to separate.
 */
export enum RenderSeparator {
  COMMA = 'COMMA',
  SEMICOLON = 'SEMICOLON',
  AND = 'AND',
  OR = 'OR'
}

/** Picker entries for the editor dialogs, with an example of what each produces. */
export const RENDER_SEPARATOR_OPTIONS: { value: RenderSeparator, label: string }[] = [
  {value: RenderSeparator.COMMA, label: 'Comma (A, B, C)'},
  {value: RenderSeparator.SEMICOLON, label: 'Semicolon (A; B; C)'},
  {value: RenderSeparator.AND, label: 'And (A and B and C)'},
  {value: RenderSeparator.OR, label: 'Or (A or B or C)'}
];
